import type Validator from '../../models/Validator';

const AlphaNumericValidator: Validator = class {
  static isValid(value, allowWhiteSpace = true) {
    if (value) {
      if (allowWhiteSpace) {
        return /^[A-Za-z0-9\s]*$/i.test(value);
      }

      return /^[A-Za-z0-9]*$/i.test(value);
    }

    return false;
  }

  static getError() {
    return null;
  }
};

export default AlphaNumericValidator;
